export const STATUS_COLOR = {
    Intake: "bg-slate-100 text-slate-700 border-slate-300",
    Discovery: "bg-blue-50 text-blue-700 border-blue-200",
    Negotiation: "bg-amber-50 text-amber-700 border-amber-200",
    Trial: "bg-purple-50 text-purple-700 border-purple-200",
    Closed: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const PRIORITY_COLOR = {
    Low: "bg-slate-50 text-slate-600 border-slate-200",
    Medium: "bg-blue-50 text-blue-700 border-blue-200",
    High: "bg-amber-50 text-amber-700 border-amber-200",
    Critical: "bg-red-50 text-red-700 border-red-200",
};

export const STAGES = ["Leads", "Consultation", "Retained"];
export const TASK_STATUS = ["Todo", "In Progress", "Review", "Done"];

export const CASE_TYPES = [
    "Personal Injury",
    "Corporate",
    "Family Law",
    "Criminal Defense",
    "Estate Planning",
    "Real Estate",
    "Immigration",
    "Intellectual Property",
];

export function fmtCurrency(n) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
}

export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    } catch {
        return "—";
    }
}

export function fmtDateTime(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
    } catch {
        return "—";
    }
}

export function daysUntil(iso) {
    if (!iso) return null;
    const now = new Date();
    const due = new Date(iso);
    return Math.ceil((due - now) / (1000 * 60 * 60 * 24));
}
